import React, { useState } from "react";
import ItemModal from "../Modal/ItemModal";
import { parseCurrency } from "../../../utils/SamuiUtils";

const ItemTable = ({
  formDetailList,
  handleChangeDetail,
  handleDuplicateRow,
  handleRemoveRow,
  formatCurrency,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  handleItemShow,
  whDataList,
  showWarehouseModal,
  handleWarehouseClose,
  handleWarehouseShow,
  onRowSelectWh,
  handleFocus,
  handleBlur,
  disabledRec,
  disabled,
  docType,
  docStatus,
  mode,
  onRowSelectItemEnter,
  setFormDetailList,
  selectionMode,
  setSelectionMode,
}) => {
  const [selectedPriceType, setSelectedPriceType] = useState(null);
  const [showGlobalPriceSelection, setShowGlobalPriceSelection] =
    useState(false);

  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้แสดง Column จำนวนรับ / จำนวนค้างรับ
  const isPurchaseOrderOrReceipt = () => {
    return (
      window.location.pathname === "/purchase-order" ||
      window.location.pathname === "/purchase-receipt"
    );
  };

  // ถ้าเป็นหน้าใบสั่งซื้อและใบรับสินค้า ให้กำหนด Width จำนวนรับ / จำนวนค้างรับ
  const getColumnWidth = () => {
    if (window.location.pathname === "/purchase-order") {
      return "13%";
    } else if (window.location.pathname === "/purchase-receipt") {
      return "21%";
    } else {
      return "21%";
    }
  };
  const handleCheckboxChange = (index) => {
    setFormDetailList((prevList) => {
      const updatedList = [...prevList];
      const currentItem = updatedList[index];

      const isGift = !currentItem.isGift; // สลับสถานะของแถม

      updatedList[index] = {
        ...currentItem,
        isGift,
        itemPriceUnit: isGift
          ? "0.00"
          : formatCurrency(
              currentItem.originalPrice || currentItem.itemPriceUnit
            ),
        itemTotal: isGift
          ? "0.00"
          : formatCurrency(currentItem.itemQty * currentItem.originalPrice),
        originalPrice: isGift
          ? currentItem.itemPriceUnit
          : currentItem.originalPrice,
      };

      return updatedList;
    });
  };

  const handleBlurPrice = (index, value) => {
    setFormDetailList((prevList) => {
      const updatedList = [...prevList];
      const currentItem = updatedList[index];

      if (!currentItem.isGift && parseFloat(value) === 0) {
        alert("ราคาต่อหน่วยต้องไม่เป็น 0 เว้นแต่เป็นของแถม");
        return prevList;
      }

      updatedList[index] = {
        ...currentItem,
        itemPriceUnit: formatCurrency(value),
      };
      return updatedList;
    });
  };

  const handleOpenPriceSelection = (index) => {
    setFormDetailList((prevList) =>
      prevList.map((item, i) =>
        i === index ? { ...item, showPriceSelection: true } : item
      )
    );
  };
  const handleclosePriceSelection = (index) => {
    setFormDetailList((prevList) =>
      prevList.map((item, i) =>
        i === index ? { ...item, showPriceSelection: false } : item
      )
    );
  };

  const selectPrice = (index, priceType) => {
    setFormDetailList((prevList) =>
      prevList.map((item, i) =>
        i === index
          ? {
              ...item,
              itemPriceUnit: item.isGift
                ? "0.00"
                : formatCurrency(item[priceType]),
              itemTotal: item.isGift
                ? "0.00"
                : formatCurrency(
                    parseFloat(item[priceType]) * parseFloat(item.itemQty || 1)
                  ),
              showPriceSelection: false,
            }
          : item
      )
    );
  };

  const selectGlobalPrice = (priceType) => {
    setFormDetailList((prevList) =>
      prevList.map((item) => ({
        ...item,
        itemPriceUnit: item.isGift ? "0.00" : formatCurrency(item[priceType]),
        itemTotal: item.isGift
          ? "0.00"
          : formatCurrency(
              parseFloat(item[priceType]) * parseFloat(item.itemQty || 1)
            ),
      }))
    );
    setShowGlobalPriceSelection(false);
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4 className="card-title">รายละเอียดสินค้า</h4>
          <button
            className="btn text-white mx-3"
            onClick={handleItemShow}
            style={{
              backgroundColor: "rgb(239, 108, 0)",
              whiteSpace: "nowrap",
              padding: "10px",
              fontSize: "15px",
            }}
            disabled={disabled}
          >
            <i className="fa fa-plus"></i> เพิ่มรายการ
          </button>
        </div>
        <ItemModal
          formDetailList={formDetailList}
          showItemModal={showItemModal}
          handleItemClose={handleItemClose}
          itemDataList={itemDataList}
          onRowSelectItem={onRowSelectItem}
          onRowSelectItemEnter={onRowSelectItemEnter}
          selectionMode={selectionMode}
          setSelectionMode={setSelectionMode}
        />
        <div className="card-body">
          <div
            className="table-responsive"
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            <table
              id="basic-datatables"
              className="table table-striped table-hover"
            >
              <thead className="thead-dark">
                <tr>
                  <th className="text-center" style={{ width: "1%" }}>
                    #
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "10%" }}
                    hidden={window.location.pathname === "/billofsale"}
                  >
                    รหัสสินค้า
                  </th>
                  <th
                    className=""
                    style={{ width: "0%", textAlign: "center" }}
                    hidden={window.location.pathname !== "/billofsale"}
                  >
                    แถม
                  </th>
                  <th
                    className="text-center"
                    style={
                      window.location.pathname === "/purchase-order"
                        ? { width: "12%" }
                        : window.location.pathname === "/billofsale"
                        ? { width: "12%" }
                        : { width: "20%" }
                    }
                  >
                    ชื่อสินค้า
                  </th>
                  <th
                    className="text-center"
                    hidden={
                      window.location.pathname !== "/billofsale" ||
                      window.location.pathname === "/bill" ||
                      // || window.location.pathname === '/order-product'
                      window.location.pathname === "/picking-list"
                        ? false
                        : true
                    }
                    style={{ width: "12%" }}
                  >
                    คลังสินค้า{" "}
                    <i
                      onClick={handleWarehouseShow}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginLeft: "35px",
                      }}
                      hidden={
                        window.location.pathname === "/bill" ||
                        window.location.pathname === "/picking-list"
                      }
                    />
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/billofsale" ||
                      window.location.pathname === "/bill" ||
                      // || window.location.pathname === '/order-product'
                      window.location.pathname === "/picking-list"
                        ? false
                        : true
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนคงเหลือ
                  </th>
                  <th className="text-center" style={{ width: "8%" }}>
                    จำนวน
                    {window.location.pathname === "/billofsale" ||
                    window.location.pathname === "/bill"
                      ? "ขาย"
                      : ""}
                    {window.location.pathname === "/order-product"
                      ? "ออเดอร์"
                      : ""}
                    {window.location.pathname === "/picking-list"
                      ? "ออเดอร์"
                      : ""}
                    {window.location.pathname === "/purchase-order"
                      ? "(PO)"
                      : ""}
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/purchase-order"
                        ? false
                        : true
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนรับ
                  </th>
                  <th
                    hidden={!isPurchaseOrderOrReceipt()}
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    จำนวนค้างรับ{" "}
                    {window.location.pathname === "/purchase-order"
                      ? "(PO)"
                      : ""}
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "6%" }}
                    hidden={
                      window.location.pathname === "/billofsale" ? true : false
                    }
                  >
                    หน่วย
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={{ width: "9%" }}
                  >
                    ราคาต่อหน่วย
                    <i
                      onClick={() => setShowGlobalPriceSelection(true)}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "12px",
                        margin: "2px",
                      }}
                      hidden={window.location.pathname !== "/billofsale"}
                    />
                    {showGlobalPriceSelection && (
                      <div
                        className="modal fade show"
                        style={{
                          display: "block",
                          position: "absolute",
                          top: "50%", // กึ่งกลางจอ
                          left: "50%", // กึ่งกลางจอ
                          transform: "translate(-50%, -50%)", // เลื่อนให้อยู่ตรงกลาง
                          zIndex: 1050, // อยู่ด้านบนสุด
                          background: "white",
                          border: "1px solid #ccc",
                          borderRadius: "10px",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", // เพิ่มเงา
                          width: "300px", // กำหนดขนาด
                          maxHeight: "800px", // ไม่ให้ยาวเกินไป
                          overflowY: "auto", // เลื่อนแนวตั้งได้
                          padding: "10px",
                          height: "300px",
                        }}
                      >
                        <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                          เลือกประเภทราคา
                        </p>
                        <hr />
                        <div className="modal-body p-2">
                          <p
                            className="m-2 p-2 "
                            // style={{ cursor: "pointer" }}
                            onClick={() => selectGlobalPrice("itemPriceUnit0")}
                          >
                            ราคา 1
                            {/* {formatCurrency(formDetailList[0]?.itemPriceUnit)} */}
                          </p>
                          <p
                            className="m-2 p-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => selectGlobalPrice("itemPriceUnitA")}
                          >
                            ราคา 2
                            {/* {formatCurrency(formDetailList[0]?.itemPriceUnitA)} */}
                          </p>
                          <p
                            className="m-2 p-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => selectGlobalPrice("itemPriceUnitB")}
                          >
                            ราคา 3
                            {/* {formatCurrency(formDetailList[0]?.itemPriceUnitB)} */}
                          </p>
                        </div>
                        <div className="modal-footer">
                          <button
                            className="btn btn-danger"
                            onClick={() => setShowGlobalPriceSelection(false)}
                          >
                            ปิด
                          </button>
                        </div>
                      </div>
                    )}
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list"
                        ? // || window.location.pathname === "/billofsale"
                          true
                        : false
                    }
                    className="text-center"
                    style={{ width: "8%" }}
                  >
                    ส่วนลด
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list"
                        ? // || window.location.pathname === "/billofsale"
                          true
                        : false
                    }
                    className="text-center"
                    style={{ width: "5%" }}
                  >
                    %
                  </th>
                  <th
                    hidden={
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list"
                        ? true
                        : false
                    }
                    className="text-center"
                    style={
                      window.location.pathname === "/deposit-document" ||
                      window.location.pathname === "/purchase-request" ||
                      window.location.pathname === "/purchase-order"
                        ? { width: "10%" }
                        : { width: "8%" }
                    }
                  >
                    จำนวนเงินรวม
                  </th>
                  <th
                    className="text-center"
                    style={{ width: getColumnWidth() }}
                    hidden={
                      window.location.pathname === "/deposit-document" ||
                      window.location.pathname === "/purchase-request" ||
                      window.location.pathname === "/purchase-order" ||
                      window.location.pathname === "/billofsale" ||
                      window.location.pathname === "/bill" ||
                      window.location.pathname === "/order-product" ||
                      window.location.pathname === "/picking-list" ||
                      window.location.pathname === "/quotation" ||
                      window.location.pathname === "/taxes"
                    }
                  >
                    คลังสินค้า
                    <i
                      onClick={handleWarehouseShow}
                      className="fa fa-search-plus"
                      style={{
                        position: "absolute",
                        cursor: "pointer",
                        fontSize: "18px",
                        marginLeft: "35px",
                      }}
                      hidden={
                        window.location.pathname === "/product-receipt" &&
                        mode === "I"
                          ? false
                          : true
                      }
                    />
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "6%" }}
                    hidden={
                      window.location.pathname === "/quotation" ||
                      window.location.pathname === "/order-product"
                        ? // ||
                          // window.location.pathname === "/billofsale"
                          false
                        : true
                    }
                  >
                    แก้ไข
                  </th>
                  <th
                    className="text-center"
                    style={{ width: "3%" }}
                    hidden={
                      window.location.pathname === "/product-receipt"
                        ? true
                        : false
                    }
                  >
                    ลบ
                  </th>
                </tr>
              </thead>
              <tbody>
                {formDetailList.length > 0 ? (
                  formDetailList.map((item, index) => (
                    <tr key={item.itemId || index + 1}>
                      {/* # */}
                      <td className="text-center">{index + 1}</td>

                      {/* รหัสสินค้า */}
                      <td
                        className="text-center"
                        hidden={
                          window.location.pathname === "/billofsale"
                            ? true
                            : false
                        }
                      >
                        <span>{item.itemCode || ""}</span>
                      </td>
                      <td
                        className="text-center"
                        hidden={window.location.pathname !== "/billofsale"}
                      >
                        <input
                          type="checkbox"
                          checked={item.isGift || false}
                          onChange={() => handleCheckboxChange(index)}
                          style={{ width: "50px" }}
                        />
                      </td>

                      {/* ชื่อสินค้า */}
                      <td className="text-left">
                        <span>
                          {window.location.pathname === "/billofsale"
                            ? `${item.itemName}${
                                item.itemUnit === ""
                                  ? ""
                                  : item.itemUnit !== null
                                  ? " x " + item.itemUnit
                                  : ""
                              }`
                            : item.itemName || ""}
                        </span>
                      </td>

                      {/* คลังสินค้า */}
                      <td
                        className="text-center"
                        hidden={
                          window.location.pathname !== "/billofsale" ||
                          window.location.pathname === "/bill" ||
                          window.location.pathname === "/picking-list"
                            ? false
                            : true
                        }
                      >
                        <select
                          name="whId"
                          value={item.whId || ""}
                          onChange={(e) =>
                            handleChangeDetail(index, "whId", e.target.value)
                          }
                          className="form-select form-control"
                          disabled={
                            window.location.pathname === "/product-receipt" ||
                            window.location.pathname === "/billofsale"
                              ? !disabled ||
                                disabledRec ||
                                window.location.pathname === "/billofsale"
                                ? true
                                : false
                              : disabled
                          }
                        >
                          <option value={""}>กรุณาเลือกคลัง</option>
                          {whDataList.map((warehouse) => (
                            <option
                              key={warehouse.WH_Id}
                              value={warehouse.WH_Id}
                            >
                              {warehouse.WH_Name}
                            </option>
                          ))}
                        </select>
                      </td>

                      {/* จำนวนคงคลัง */}
                      <td
                        hidden={
                          window.location.pathname === "/billofsale" ||
                          window.location.pathname === "/bill" ||
                          window.location.pathname === "/picking-list"
                            ? false
                            : true
                        }
                        className="text-center"
                      >
                        {item.itemOnHand === "-" ? ( // ถ้า loading เป็น true หรือ itemOnHand ไม่มีค่า
                          <i className="fa fa-spinner fa-spin"></i>
                        ) : (
                          <span>{formatCurrency(item.itemOnHand) || 0}</span>
                        )}
                      </td>

                      {/* จำนวน */}
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control text-center"
                          value={item.itemQty || ""}
                          onChange={(e) =>
                            handleChangeDetail(index, "itemQty", e.target.value)
                          }
                          onFocus={(e) => handleFocus(index, "itemQty", e)}
                          onBlur={(e) =>
                            handleBlur(index, "itemQty", e.target.value)
                          }
                          disabled={
                            window.location.pathname === "/product-receipt"
                              ? !disabled || disabledRec
                                ? true
                                : false
                              : disabled
                          }
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                              e.target.value = inputValue.slice(0, -1);
                            }
                          }}
                        />
                      </td>

                      {/* จำนวนรับ */}
                      <td
                        hidden={
                          window.location.pathname === "/purchase-order"
                            ? false
                            : true
                        }
                        className="text-center"
                      >
                        {/* {disabled ? (
                                                <span>{item.itemRecQty || 0}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={item.itemRecQty || 0}
                                                    onChange={(e) => handleChangeDetail(index, 'itemRecQty', e.target.value)}
                                                    disabled={disabled}
                                                />
                                            )} */}
                        <input
                          type="text"
                          className="form-control text-center"
                          value={item.itemRecQty || 0}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "itemRecQty",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                          onInput={(e) => {
                            if (/^0+/.test(e.target.value)) {
                              e.target.value = e.target.value.replace(
                                /^0+/,
                                ""
                              );

                              // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                              if (e.target.value.startsWith(".")) {
                                e.target.value = "0" + e.target.value;
                              }
                            }
                          }}
                        />
                      </td>

                      {/* จำนวนค้างรับ */}
                      <td
                        hidden={!isPurchaseOrderOrReceipt()}
                        className="text-center"
                      >
                        {/* {disabled ? (
                                                <span>{item.itemRecBalance || 0}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control text-center"
                                                    value={item.itemRecBalance || 0}
                                                    onChange={(e) => handleChangeDetail(index, 'itemRecBalance', e.target.value)}
                                                    disabled={disabled}
                                                />
                                            )} */}
                        <input
                          type="text"
                          className="form-control text-center"
                          value={item.itemRecBalance || 0}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "itemRecBalance",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                          onInput={(e) => {
                            if (/^0+/.test(e.target.value)) {
                              const inputValue = e.target.value;

                              // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                              if (
                                inputValue.startsWith(".") &&
                                inputValue !== "."
                              ) {
                                e.target.value = "0" + inputValue;
                              }
                            }
                          }}
                        />
                      </td>

                      {/* หน่วย */}
                      <td
                        className="text-center"
                        hidden={
                          window.location.pathname === "/billofsale"
                            ? true
                            : false
                        }
                      >
                        {/* {disabled ? (
                                                <span>{item.itemUnit || ''}</span>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.itemUnit || ''}
                                                    disabled={true}
                                                    onChange={(e) => handleChangeDetail(index, 'itemUnit', e.target.value)}
                                                />
                                            )} */}
                        <input
                          type="text"
                          className="form-control"
                          value={item.itemUnit || ""}
                          disabled={true}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "itemUnit",
                              e.target.value
                            )
                          }
                        />
                      </td>

                      {/* ราคาต่อหน่วย */}
                      <td
                        className="text-end"
                        hidden={
                          window.location.pathname === "/order-product" ||
                          window.location.pathname === "/picking-list"
                            ? true
                            : false
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          {/* Input สำหรับแสดงราคาต่อหน่วย และสามารถกดแก้ไขได้ */}
                          {item.isEditingPrice ? (
                            <>
                              {item.showPriceSelection ? null : (
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  value={item.itemPriceUnit || ""}
                                  onChange={(e) => {
                                    const newValue = e.target.value;
                                    // ตรวจสอบว่าเป็นของแถมหรือไม่
                                    if (
                                      !item.isGift &&
                                      parseFloat(newValue) === 0
                                    ) {
                                      alert(
                                        "ราคาต่อหน่วยต้องไม่เป็น 0 เว้นแต่เป็นของแถม"
                                      );
                                      return;
                                    }
                                    handleChangeDetail(
                                      index,
                                      "itemPriceUnit",
                                      newValue
                                    );
                                  }}
                                  onFocus={(e) =>
                                    handleFocus(index, "itemPriceUnit", e)
                                  }
                                  onBlur={(e) =>
                                    handleBlur(
                                      index,
                                      "itemPriceUnit",
                                      e.target.value
                                    )
                                  }
                                  disabled={disabled || item.isGift}
                                  style={{
                                    paddingRight: "30px", // เพิ่มพื้นที่ขวาให้ปุ่ม 🔍
                                  }}
                                />
                              )}
                            </>
                          ) : (
                            <>
                              {item.showPriceSelection ? null : (
                                <>
                                  <input
                                    type="text"
                                    className="form-control text-end"
                                    value={item.itemPriceUnit || ""}
                                    readOnly
                                    onClick={() =>
                                      setFormDetailList((prevList) =>
                                        prevList.map((itm, i) =>
                                          i === index
                                            ? { ...itm, isEditingPrice: true }
                                            : itm
                                        )
                                      )
                                    }
                                    style={{
                                      paddingRight: "30px",
                                      cursor: "pointer",
                                    }}
                                    onFocus={(e) =>
                                      handleFocus(index, "itemPriceUnit", e)
                                    }
                                    onBlur={(e) =>
                                      handleBlur(
                                        index,
                                        "itemPriceUnit",
                                        e.target.value
                                      )
                                    }
                                    disabled={disabled || item.isGift}
                                  />
                                </>
                              )}
                            </>
                          )}

                          {/* ปุ่มค้นหา (🔍) */}
                          {!item.showPriceSelection && (
                            <i
                              className="fa fa-search-plus"
                              style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor:
                                  disabled || item.isGift
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: disabled || item.isGift ? 0.5 : 1, // ทำให้จางลงถ้า disabled
                                fontSize: "14px",
                                color: "#007bff",
                              }}
                              onClick={() => {
                                if (!disabled && !item.isGift) {
                                  //  ตรวจสอบก่อนคลิก
                                  setFormDetailList((prevList) =>
                                    prevList.map((itm, i) =>
                                      i === index
                                        ? { ...itm, showPriceSelection: true }
                                        : itm
                                    )
                                  );
                                }
                              }}
                            />
                          )}
                        </div>

                        {/* Dropdown เลือกประเภทของราคา */}
                        {item.showPriceSelection && (
                          <select
                            className="form-select mt-1"
                            value={item.itemPriceUnit || ""}
                            autoFocus
                            onChange={(e) => {
                              const newPrice = e.target.value;

                              // ตรวจสอบว่าถ้าไม่ใช่ของแถม ราคาต้องไม่เป็น 0
                              if (!item.isGift && parseFloat(newPrice) === 0) {
                                alert(
                                  "ราคาต่อหน่วยต้องไม่เป็น 0 เว้นแต่เป็นของแถม"
                                );
                                return;
                              }

                              setFormDetailList((prevList) =>
                                prevList.map((itm, i) =>
                                  i === index
                                    ? {
                                        ...itm,
                                        itemPriceUnit: newPrice,
                                        itemTotal: formatCurrency(
                                          parseFloat(newPrice) *
                                            parseFloat(itm.itemQty || 1)
                                        ),
                                        showPriceSelection: false, // ปิด dropdown หลังจากเลือก
                                        isEditingPrice: true, // เปิดโหมดแก้ไขทันทีหลังเลือก
                                      }
                                    : itm
                                )
                              );
                            }}
                            onBlur={() => {
                              setFormDetailList((prevList) =>
                                prevList.map((itm, i) =>
                                  i === index
                                    ? { ...itm, showPriceSelection: false }
                                    : itm
                                )
                              );
                            }}
                          >
                            <option value="">เลือกราคา</option>
                            <option value={item.itemPriceUnit0}>
                              ราคา 1: {formatCurrency(item.itemPriceUnit0)}
                            </option>
                            <option value={item.itemPriceUnitA}>
                              ราคา 2: {formatCurrency(item.itemPriceUnitA)}
                            </option>
                            <option value={item.itemPriceUnitB}>
                              ราคา 3: {formatCurrency(item.itemPriceUnitB)}
                            </option>
                          </select>
                        )}
                      </td>

                      {/* ส่วนลด */}
                      <td
                        hidden={
                          window.location.pathname === "/order-product" ||
                          window.location.pathname === "/picking-list"
                            ? // || window.location.pathname === "/billofsale"
                              true
                            : false
                        }
                        className="text-end"
                      >
                        <input
                          type="text"
                          className="form-control text-end"
                          value={item.itemDiscount || ""}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "itemDiscount",
                              e.target.value
                            )
                          }
                          onFocus={(e) => handleFocus(index, "itemDiscount", e)}
                          onBlur={(e) =>
                            handleBlur(index, "itemDiscount", e.target.value)
                          }
                          disabled={disabled}
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                              e.target.value = inputValue.slice(0, -1);
                            }
                          }}
                        />
                      </td>

                      {/* % */}
                      <td
                        hidden={
                          window.location.pathname === "/order-product" ||
                          window.location.pathname === "/picking-list"
                            ? // || window.location.pathname === "/billofsale"
                              true
                            : false
                        }
                        className="text-center"
                      >
                        {/* {disabled ? (
                                                <span>{item.itemDisType === "1" ? "฿" : item.itemDisType === "2" ? "%" : ""}</span>
                                            ) : (
                                                <select
                                                    className="form-select"
                                                    value={item.itemDisType || ''}
                                                    onChange={(e) => handleChangeDetail(index, 'itemDisType', e.target.value)}
                                                    disabled={disabled}
                                                >
                                                    <option value="1">฿</option>
                                                    <option value="2">%</option>
                                                </select>
                                            )} */}
                        <select
                          className="form-select"
                          value={item.itemDisType || ""}
                          onChange={(e) =>
                            handleChangeDetail(
                              index,
                              "itemDisType",
                              e.target.value
                            )
                          }
                          disabled={disabled}
                        >
                          <option value="1">฿</option>
                          <option value="2">%</option>
                        </select>
                      </td>

                      {/* จำนวนเงินรวม */}
                      <td
                        hidden={
                          window.location.pathname === "/order-product" ||
                          window.location.pathname === "/picking-list"
                            ? true
                            : false
                        }
                        className="text-end"
                      >
                        <span>{formatCurrency(item.itemTotal || 0)}</span>
                      </td>

                      {/* คลังสินค้า */}
                      <td
                        className="text-center"
                        hidden={[
                          "/deposit-document",
                          "/purchase-request",
                          "/purchase-order",
                          "/order-product",
                          "/picking-list",
                          "/billofsale",
                          "/bill",
                          "/quotation",
                          "/taxes",
                        ].includes(window.location.pathname)}
                      >
                        {(() => {
                          return window.location.pathname ===
                            "/product-receipt" && mode === "U" ? (
                            <>
                              {item.whId ? (
                                whDataList
                                  .filter(
                                    (warehouse) =>
                                      parseCurrency(warehouse.WH_Id) ===
                                      parseCurrency(item.whId)
                                  )
                                  .map((warehouse) => (
                                    <span key={warehouse.WH_Id}>
                                      {warehouse.WH_Name || "ไม่ระบุคลัง"}
                                    </span>
                                  ))
                              ) : (
                                <span>ไม่ระบุคลัง</span>
                              )}
                            </>
                          ) : (
                            <select
                              name="whId"
                              value={item.whId}
                              onChange={(e) =>
                                handleChangeDetail(
                                  index,
                                  "whId",
                                  e.target.value
                                )
                              }
                              className="form-select form-control"
                              disabled={
                                window.location.pathname === "/product-receipt"
                                  ? !disabled || disabledRec
                                  : disabled
                              }
                            >
                              <option value={""}>กรุณาเลือกคลัง</option>
                              {whDataList.map((warehouse) => (
                                <option
                                  key={warehouse.WH_Id}
                                  value={warehouse.WH_Id}
                                >
                                  {warehouse.WH_Name}
                                </option>
                              ))}
                            </select>
                          );
                        })()}
                      </td>

                      {/* แก้ไข */}
                      <td
                        className="text-center"
                        hidden={
                          window.location.pathname === "/quotation" ||
                          window.location.pathname === "/order-product"
                            ? // ||window.location.pathname === "/billofsale"
                              false
                            : true
                        }
                      >
                        <button
                          type="button"
                          className="btn btn-warning"
                          onClick={() => handleDuplicateRow(index)}
                          disabled={disabled}
                        >
                          ทำซ้ำ
                        </button>
                      </td>

                      {/* ลบ */}
                      <td
                        className="text-center"
                        hidden={
                          window.location.pathname === "/product-receipt"
                            ? true
                            : false
                        }
                      >
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => handleRemoveRow(index)}
                          disabled={disabled}
                        >
                          ลบ
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="13">
                      <center>
                        <h5>ไม่พบรายการสินค้า</h5>
                      </center>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Modal คลังสินค้า */}
            <div
              className={`modal fade ${showWarehouseModal ? "show" : ""}`}
              style={{ display: showWarehouseModal ? "block" : "none" }}
              tabIndex="-1"
              role="dialog"
            >
              <div
                className="modal-dialog modal-lg"
                style={{ maxWidth: "35%" }}
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <div className="d-flex align-items-center">
                      <h4 className="card-title">คลังสินค้า</h4>
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleWarehouseClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div
                      className="table-responsive"
                      style={{ maxHeight: "650px", overflowY: "auto" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-dark">
                          <tr>
                            <th
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              รหัสคลังสินค้า
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "80%" }}
                            >
                              ชื่อคลังสินค้า
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {whDataList && whDataList.length > 0 ? (
                            whDataList.map((warehouse, index) => (
                              <tr
                                key={warehouse.Item_Id || index + 1}
                                onClick={() => onRowSelectWh(warehouse)}
                                style={{ cursor: "pointer" }}
                              >
                                <td className="text-center">
                                  {warehouse.WH_Code}
                                </td>
                                <td className="text-left">
                                  {warehouse.WH_Name}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">
                                <center>
                                  <h5>ไม่พบข้อมูล</h5>
                                </center>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-lg btn-danger"
                      onClick={handleWarehouseClose}
                    >
                      ปิด
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {showWarehouseModal && (
              <div className="modal-backdrop fade show"></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemTable;
